module.exports = __webpack_public_path__ + "static/media/topsecret2.788505db.jpg";